import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CookieService {
  setCookie(name: string, value: string, days: number = 365) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/`;
  }

  getCookie(name: string): string | boolean | null {
    const cookieName = `${name}=`;
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
      const cookieValue = cookie.trim();

      if (cookieValue.startsWith(cookieName)) {
        const value = cookieValue.substring(
          cookieName.length,
          cookieValue.length,
        );
        if (value.toLowerCase() === 'true') {
          return true;
        } else if (value.toLowerCase() === 'false') {
          return false;
        }
        return value;
      }
    }
    return null;
  }

  deleteCookie(name: string) {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
  }
}
